import { useCookies } from "react-cookie"
import { useRecoilValue } from "recoil"
import { quizResponseCntSelector } from "../../recoil/QuizPage/selectors"
import { useEffect, useState } from "react"

const useQuizProgress = () => {
  const [cookie] = useCookies(["quizRound"])
  const quizResponseCnt = useRecoilValue(quizResponseCntSelector)
  const totalQuizItemCnt = 100
  const [quizProgress, setQuizProgress] = useState(0)

  const calculated =
    (((cookie.quizRound - 1) * 20 + quizResponseCnt) / totalQuizItemCnt) * 100

  useEffect(() => {
    setQuizProgress((prev) => Math.max(prev, calculated))
  }, [setQuizProgress, calculated])

  return quizProgress
}

export default useQuizProgress
